export const ORDER_NAME = 'Order Name';

export const TEAM_MEMBERS = 'Team Members';

export const ORGANIZATION = 'Organization';

export const PHONE_NUMBER = 'Phone Number';

export const PROJECT = 'Project';

export const TEAM = 'Team';

export const ACCOUNT_REP = 'Account Rep';

export const TAT = 'Turnaround Time';

export const PATH_CONTRIBUTION = 'Order Contributes to Pathology Map';

export const FIXATION_TIME_HELP_TOOLTIP_TEXT =
  'Note, this is the duration of time the samples have been in fixative solution. We recommend neutral buffered formalin for 24 hours, but this depends on the sample size and tissue type.';
export const SAMPLES_AT_HISTOWIZ_TOOLTIP_TEXT =
  'Select "Yes" if you are using samples from a previous completed HistoWiz order and the materials are still at our facility. Select "No" if you will be shipping us materials.';
export const SECTIONS_PER_SLIDE_TOOLTIP_TEXT =
  'Note, this refers to how many sections you would like on an individual slide, not how many sections total per sample. For example, selecting 2 means you will receive 2 tissue sections on 1 slide.';
export const ADDITIONAL_STEPS_TOOLTIP_TEXT =
  'Note, this refers to any steps you would like taken during sectioning. A level refers to a plane within the tissue separated by a specified distance in microns. A step refers to the gap separating the levels. For example, requesting two steps at 50um implies you would like 3 sections taken with two 50um gaps in between the first and second slide and the second and third slide. Please include the specific micron distance you would like your levels taken at in the special instructions box.';
